import { createSlice } from "@reduxjs/toolkit"
import apiService from "services/apiService"
import { isAdminRoute } from "helper/helper"
import usersApiSlice from "services/admin/usersApiSlice"

const getInitialState = (user) => {
  if (isAdminRoute()) {
    sessionStorage.setItem(
      "accessToken",
      localStorage.getItem("adminAccessToken")
    )
    // user = JSON.parse(localStorage.getItem("admin"));
  } else {
    // user = JSON.parse(localStorage.getItem("user"));
    sessionStorage.setItem(
      "accessToken",
      localStorage.getItem("userAccessToken")
    )
  }
  return {
    email: "",
    user: user || {},
    isLogin: !!user,
    errorFetching: false,
  }
}

const filter = (action) => {
  return [slice.actions.logout.type].includes(action.type)
}

const slice = createSlice({
  name: "auth",
  initialState: getInitialState(),
  reducers: {
    logout: (state) => {
      sessionStorage.clear()
      if (isAdminRoute()) {
        //remove admin related data
        localStorage.removeItem("admin")
        localStorage.removeItem("adminAccessToken")
        localStorage.removeItem("adminForgotToken")
      } else {
        localStorage.removeItem("user")
        localStorage.removeItem("userAccessToken")
        localStorage.removeItem("userForgetToken")
      }
      if (isAdminRoute()) {
        window.location.replace("/admin/login")
      } else window.location.replace("/")
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      apiService.endpoints.login.matchFulfilled,
      (state, { payload }) => {
        const { data } = payload
        state.email = data.email
        state.user = data
        state.isLogin = true
        if (data?.userType == 2) {
          state.user = data
          localStorage.setItem("userAccessToken", data.accessToken)
          localStorage.setItem("userForgetToken", data.forgotToken)
        }
        if (data?.userType == 3) {
          state.admin = data
          localStorage.setItem("adminAccessToken", data.accessToken)
          localStorage.setItem("adminForgotToken", data.forgotToken)
        }

        sessionStorage.setItem("accessToken", data.accessToken)
        sessionStorage.setItem("forgotToken", data.forgotToken)
        state.email = payload.data?.email
        // if (isAdminRoute()) {
        //   window.location.replace("/admin");
        // }
        //  else window.location.replace("/");
      }
    )
    builder.addMatcher(
      apiService.endpoints.getUserDetails.matchFulfilled,
      (state, { payload }) => {
        const pay = getInitialState(payload)
        state.user = pay.user
        state.isLogin = true
      }
    )
    builder.addMatcher(
      apiService.endpoints.getUserDetails.matchRejected,
      (state, { payload }) => {
        state.user = {}
        state.isLogin = false
      }
    )
    builder.addMatcher(
      usersApiSlice.endpoints.updateUserPatch.matchFulfilled,
      (state, action) => {
        const patch = action.meta.arg.originalArgs
        state.user = {
          ...state.user,
          ...patch,
        }
      }
    )

    builder.addMatcher(filter, (state, action) => {
      state = getInitialState()
    })
  },
})

export const selectPracticeAndDepartmentId = (state) => {
  return {
    departmentid: state.user.user.departmentId,
    practiceid: state.user.user.practiceId,
  }
}

export default slice.reducer

export const { logout } = slice.actions
